import { Button, ButtonColor } from '@swivl-mono/ui';
import ModalModel from '../../../../Models/Modal/Modal.Model';
import MembersModel from '../../../../Models/Member/Members.Model';
import "./StartShiftModal.scss"
import { Member } from '../../../../Models/Member/Member.Current';

export const StartShiftModal = (props) => {
  const goOnlineClicked = () => {
    Member.hasSeenStartShiftModal = true
    MembersModel.setAvailability(true)
    ModalModel.hideModal()
  }
  const stayOfflineClicked = () => {
    Member.hasSeenStartShiftModal = true

    MembersModel.setAvailability(false)
    ModalModel.hideModal()
  }

  return <div className="StartShiftModal">
    <h1>🦸‍♀ 💬 👨‍💻</h1>
    <h2>Welcome to your shift</h2>
    <h3>Do you want to turn your availability on?</h3>

    <div className="buttons">
      <Button color={ButtonColor.BLACK} onClick={stayOfflineClicked}>Stay Offline</Button>
      <Button color={ButtonColor.ORANGE} onClick={goOnlineClicked}>Go Online</Button>
    </div>
  </div>;
}
